var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "file",
    width: 20.452,
    height: 25.565,
    viewBox: "0 0 20.452 25.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90a5c7",
    id: "Path_1070",
    d: "M82.322 41.565a2.133 2.133 0 0 0 2.13-2.13v-17.9a.426.426 0 0 0-.125-.3l-5.113-5.113a.426.426 0 0 0-.3-.125H66.13A2.133 2.133 0 0 0 64 18.13v21.3a2.133 2.133 0 0 0 2.13 2.13zm-2.983-24.11L83 21.113h-2.38a1.28 1.28 0 0 1-1.278-1.278zm-14.487 21.98V18.13a1.28 1.28 0 0 1 1.278-1.278h12.357v2.983a2.133 2.133 0 0 0 2.13 2.13H83.6v17.47a1.28 1.28 0 0 1-1.278 1.278H66.13a1.28 1.28 0 0 1-1.278-1.278z",
    className: "cls-1",
    transform: "translate(-64 -16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a5c7",
    id: "Path_1071",
    d: "M219.835 376h-3.409a.426.426 0 1 0 0 .852h3.409a.426.426 0 1 0 0-.852z",
    className: "cls-1",
    transform: "translate(-207.904 -356.826)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a5c7",
    id: "Path_1072",
    d: "M168.426 157.965h2.13v4.687a.426.426 0 0 0 .426.426h3.409a.426.426 0 0 0 .426-.426v-4.687h2.13a.426.426 0 0 0 .327-.7l-4.261-5.113a.426.426 0 0 0-.655 0l-4.261 5.113a.426.426 0 0 0 .327.7zm4.261-4.873l3.351 4.021h-1.647a.426.426 0 0 0-.426.426v4.687h-2.557v-4.687a.426.426 0 0 0-.426-.426h-1.647z",
    className: "cls-1",
    transform: "translate(-162.461 -144.757)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.a370f2c627fb36a621224e6077698d30.svg";
export { ForwardRef as ReactComponent };